//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { koSpeakers, jaSpeakers } from '@/data/webinar-speakers/index.js';

export default {
  name: 'SubscribeWebinars',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      imageBaseUrl: 'https://static.moele.me/img/channels2022/webinars221213',
    };
  },
  computed: {
    webinar() {
      switch (this.$i18n.locale) {
        case 'ko':
          return {
            speakers: koSpeakers,
            banners: {
              heading: '모든 크리에이터를 위한 특별한 웨비나',
              text: '모션엘리먼츠는 영상 제작자 및 그래픽 디자이너를 위한 주제의 웨비나를 진행하며 여러분들과 소통하고 있습니다. 영상 및 디자인 관련 전문가 및 인플루언서를 초청하여 다른 플랫폼에서는 만나볼 수 없는 영상 제작 노하우와 비하인드 더 씬, 소프트웨어 사용 팁 및 AI 최신 동향 등을 소개합니다. 모션엘리먼츠 웨비나 페이지에서 예정된 LIVE 웨비나 참가 신청 뿐만 아니라 지난 웨비나의 동영상까지 모두 자유롭게 시청하세요!',
              bg: `${this.imageBaseUrl}/ko/bg.png?auto=format&w=1234`,
            },
          };
        case 'ja':
          return {
            speakers: jaSpeakers,
            banners: {
              heading: '定額プラン会員だけの限定ウェビナー',
              text: '会員限定の<wbr>映像クリエイター向け<wbr>ウェビナー<wbr>が視聴可能です。<wbr>第一線で活躍している<wbr>動画クリエイター<wbr>やインフルエンサーに<wbr>よる制作<wbr>ノウハウや<wbr>制作の裏側、<wbr>テンプレート・<wbr>素材活用の<wbr>ヒントなど、<wbr>他プラットフォームには<wbr>無いここだけの<wbr>ウェビナー<wbr>動画が<wbr>充実しています。<wbr>また、<wbr>会員であれば<wbr>全ての<wbr>LIVE<wbr>ウェビナーに<wbr>無料参加でき、<wbr>過去<wbr>ウェビナー動画も<wbr>全て<wbr>視聴可能です。',
              bg: `${this.imageBaseUrl}/ja/bg.png?auto=format&w=1234`,
            },
          };
        default:
          return null;
      }
    },
  },
};
